import Utils from "../../utils/Utils";

export default {

    init() {

        const INPUT_TAXABLE = "#input-taxable";
        const INPUT_TAX = "#input-tax";
        const INPUT_TOTAL = "#input-total";

        function getTaxable() {
            const taxable = $(INPUT_TAXABLE).val();

            if (Utils.isEmpty(taxable)) {
                return 0;
            }

            return parseFloat(taxable);
        }

        function getTax() {
            const tax = $(INPUT_TAX).val();

            if (Utils.isEmpty(tax)) {
                return 0;
            }

            return parseFloat(tax);
        }

        function setTotal(taxable, tax) {

            const total = parseFloat(taxable) + parseFloat(tax)
            $(INPUT_TOTAL).val(total.toFixed(2));
        }

        function fillData() {
            const taxable = getTaxable();
            const tax = getTax();

            setTotal(taxable, tax);
        }

        $(INPUT_TAXABLE).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAXABLE).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAX).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAX).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        fillData();
    },

    finalize() {

    }
}
